import { ojs } from "modular-openscriptjs";
import { Analytics } from "./Analytics";
import { AiCredit } from "./AiCredit";
import { AnnouncementMediator } from "./AnnouncementMediator";
import { Auth } from "./Auth";
import { DeliveryAddress } from "./DeliveryAddress";
import { LocationMediator } from "./Location";
import { Order } from "./Order";
import { Payment } from "./Payment";
import { Product } from "./Product";
import { QRCode } from "./QRCode";
import { Review } from "./Review";
import { Setting } from "./Setting";
import { User } from "./User";
import { Utility } from "./Utility";
import MpesaPayment from "./PaymentMethods/MpesaPayment";
import AppStorePayment from "./PaymentMethods/AppStorePayment";
import System from "./System";
import Tour from "./Tour";
import BranchMediator from "./BranchMediator";
import ServiceMediator from "./ServiceMediator";
import DealMediator from "./DealMediator";
import CompanyMediator from "./CompanyMediator";
import { BusinessVoiceOrderCall } from "./BusinessVoiceOrderCall";

ojs(
	System,
    Tour,
	Analytics,
	AiCredit,
	AnnouncementMediator,
	Auth,
	DeliveryAddress,
	LocationMediator,
	BranchMediator,
	ServiceMediator,
	DealMediator,
	Order,
	Payment,
	Product,
	QRCode,
	Review,
	Setting,
	User,
	Utility,
	MpesaPayment,
	AppStorePayment,
    CompanyMediator,
	BusinessVoiceOrderCall
);
